import { ReactElement, memo } from 'react'
import { Navigate, PathRouteProps, useLocation } from 'react-router-dom'

import { usePersistStore } from '@shared/hooks/usePersistStore'

interface PrivateRouteProps extends PathRouteProps {
  isAuthenticated: boolean
  children: ReactElement
}

const PrivateRoute = ({ isAuthenticated, children }: PrivateRouteProps) => {
  const location = useLocation()
  const { persistUrlData, setChatModalOpen, setChatIdToOpen, previousUrlPathname, previousUrlSearch } = usePersistStore()

  if (isAuthenticated) {
    if (previousUrlPathname && previousUrlPathname !== location.pathname) {
      return <Navigate replace to={`${previousUrlPathname}${previousUrlSearch || ''}`} />
    }
    return children
  }

  if (!['/sign-in', '/plus/hub'].includes(window.location.pathname) || window.location.search?.length) {
    persistUrlData()
  }

  if (location?.search?.includes('chat-modal-open')) {
    setChatModalOpen(true)
  }

  if (location?.search?.includes('chat-id-to-open')) {
    const splittedSearch = location.search.split('=')
    if (splittedSearch[1]) {
      setChatIdToOpen(splittedSearch[1])
    }
  }

  return <Navigate replace to="/sign-in" />
}

export default memo(PrivateRoute)
